
import { defineComponent } from 'vue';
import ScheduleTemplate from '@/components/templates/program/ScheduleTemplate.vue';
import { useI18n } from '@/plugins/i18n';
import JaMessages from '@/assets/i18n/ja/program/schedule.json';
import EnMessages from '@/assets/i18n/en/program/schedule.json';
import { pageview } from 'vue-gtag';

export default defineComponent({
  name: 'Schedule',
  components: { ScheduleTemplate },
  methods: {
    track() {
      pageview({ page_path: '/program/schedule' });
    },
  },
  setup() {
    const i18n = useI18n();
    i18n.$setMessages(JaMessages, EnMessages);

    return {
      i18n,
    };
  },
});
